import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import ObjectDataroom from './ObjectDataroom';

interface Doc {
    id?: string | number;
    document_id?: string | number;
    url: string;
    name: string;
    contentType: string;
    size: number;
    lastModified: string;
    etag: string;
}

interface ObjectDocsFormProps {
    open: boolean;
    onClose: () => void;
    objectId: string | number | null;
    onFileDrop?: (file: File, objectId: string | number) => Promise<void> | void;
    canUpload?: boolean;
}

export default function ObjectDocsForm({ open, onClose, objectId, onFileDrop, canUpload = false }: ObjectDocsFormProps) {
    // Visual helper removed — not used in this component. Use `ObjectDataroom` for rendering file visuals.

    return (
        <Dialog open={open} onClose={onClose} maxWidth='md' fullWidth>
            <DialogTitle>Dataroom for Object {objectId}</DialogTitle>
            <DialogContent>
                <ObjectDataroom objectId={objectId} canUpload={canUpload} onFileDrop={onFileDrop} />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}
